import {FC} from "react";

interface IProps {
    item: {
        textEditorValue: string;
        customClassNames: string;
        convertedSettings: {
            animationAos: { "data-aos": any },
            styles: any;
            parentStyles: any
        }
    }
}

const Editor: FC<IProps> = (
    {
        item: {
            textEditorValue,
            customClassNames,
            convertedSettings: {
                animationAos: {"data-aos": dataAos = null} = {},
                styles = {},
                parentStyles = {}
            } = {}
        }
    }
) => {
    return (
        <div data-aos={dataAos} className={customClassNames} style={parentStyles}>
            <div style={styles} dangerouslySetInnerHTML={{ __html: textEditorValue }}/>
        </div>
    );
};

export default Editor;
